import { CircularLoader } from '@modules/common/components/CircularLoader';
import { MetadataFieldMappingFeedbackMatchCount } from '@modules/integrationsV2/components/LinkIntegrationMetadata/MetadataFieldMappingList/MetadataFieldMappingFeedbackMatchCount';
import { MetadataFieldMappingUserMatchCount } from '@modules/integrationsV2/components/LinkIntegrationMetadata/MetadataFieldMappingList/MetadataFieldMappingUserMatchCount';
import { LinkRounded } from '@mui/icons-material';
import { Stack } from '@mui/material';
import { EqlField, ObjectType } from 'generated/graphql';

interface MetadataFieldMappingLinkIconProps {
  sourceEqlField: EqlField | undefined;
  targetEqlField: EqlField | undefined;
  isLoading: boolean;
  isLinked: boolean;
}

export const MetadataFieldMappingLinkIcon = ({
  sourceEqlField,
  targetEqlField,
  isLinked,
  isLoading,
}: MetadataFieldMappingLinkIconProps) => {
  if (isLoading) {
    return <CircularLoader size={24} />;
  }

  if (!isLinked) {
    return (
      <LinkRounded
        sx={{
          color: 'text.disabled',
          fontSize: '1.8rem',
        }}
      />
    );
  }

  const renderLinkMatchCount = () => {
    if (!sourceEqlField || !targetEqlField) {
      return null;
    }

    if (
      sourceEqlField.objectType === ObjectType.Feedback ||
      targetEqlField.objectType === ObjectType.Feedback
    ) {
      return (
        <MetadataFieldMappingFeedbackMatchCount
          sourceEqlField={sourceEqlField}
          targetEqlField={targetEqlField}
        />
      );
    }

    if (
      sourceEqlField.objectType === ObjectType.User ||
      targetEqlField.objectType === ObjectType.User
    ) {
      return (
        <MetadataFieldMappingUserMatchCount
          sourceEqlField={sourceEqlField}
          targetEqlField={targetEqlField}
        />
      );
    }

    return null;
  };

  return (
    <Stack spacing={0.5} alignItems="center" justifyContent="center">
      <LinkRounded
        sx={{
          color: 'success.light',
          fontSize: '1.8rem',
        }}
      />
      {renderLinkMatchCount()}
    </Stack>
  );
};
